import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading, isAdmin } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-lsfc-blue-600"></div>
      </div>
    );
  }

  if (!user) {
    // Redirect to the correct login based on the current route
    const loginUrl = location.pathname.startsWith('/representante')
      ? '/login?tipo=representante'
      : '/login';
    return <Navigate to={loginUrl} replace />;
  }

  if (adminOnly && !isAdmin()) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
